type SignatoryUserLike = Record<string, unknown>;

export const shapeSignatoryUser = (signatoryUser: unknown): SignatoryUserLike | undefined => {
  if (!signatoryUser || typeof signatoryUser !== "object") return undefined;

  const user = signatoryUser as SignatoryUserLike;
  const shaped: SignatoryUserLike = {
    email: user.email,
    name: user.name,
    mobile: user.mobile,
    designation: user.designation,
    company: user.company,
  };

  if (user.arabicName) shaped.arabicName = user.arabicName;
  if (user.countryCode) shaped.countryCode = user.countryCode;

  const hasValue = Object.values(shaped).some((value) => value != null && value !== "");
  return hasValue ? shaped : undefined;
};
